import { httpRequest } from '@/services/httpClient'

export type RoleItem = {
  roleId: number
  tenantId: number | null
  name: string
  code: string | null
  description: string | null
  isSystemRole: boolean | null
  isActive?: boolean
  isDeleted?: boolean
  createdAt?: string
  lastUpdated?: string
}

export type RoleListResponse = {
  items: RoleItem[]
  totalCount: number
  page: number
  pageSize: number
}

export type RoleListParams = {
  tenantId?: number
  isActive?: boolean
  includeDeleted?: boolean
  page?: number
  pageSize?: number
}

export const rolesApi = {
  list: (params: RoleListParams) =>
    httpRequest<RoleListResponse>('/v1/roles', {
      method: 'GET',
      query: {
        tenantId: params.tenantId ?? undefined,
        isActive: params.isActive ?? undefined,
        includeDeleted: params.includeDeleted ?? undefined,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 100,
      },
    }),
}
